import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import resultName from "../../styles/images/img_change_name.png";
import resultEmail from "../../styles/images/img_change_email.png";
import resultPassword from "../../styles/images/img_change_password.png";
import resultPhone from "../../styles/images/img_change_phone.png";
import OnePageLayout from "../../components/layout/OnePageLayout";
import { returnTypeIs } from "../../components/hooks/basicFunc";
import { Modal } from "../../components/modal/Modal";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";
import { authActions } from "../../store/slices/authSlice";
import { useDispatch } from "react-redux";
import { getToken } from "../../components/hooks/authFunc";

const EditInfoResult = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = getToken();
  const type = location.state.type;
  const [openModal, setOpenModal] = useState(false);
  const returnTypeImg = (type) => {
    switch (type) {
      case "name":
        return resultName;
        break;
      case "email":
        return resultEmail;
        break;
      case "password":
        return resultPassword;
        break;
      case "phone":
        return resultPhone;
        break;
      default:
        return "";
    }
  };
  const handleLogout = () => {
    const params = {};
    dispatch(authActions.fetchLogout({ accessToken, params, page: "login" }));
  };

  return (
    <OnlyHeaderLayout title="회원정보">
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          title="비밀번호 재설정 완료"
          callbackFunc={() => handleLogout()}
        >
          <div>
            <p>
              비밀번호가 재설정 되었습니다.
              <br />
              다시 로그인해 주세요!
            </p>
          </div>
          {/* <div>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</div> */}
        </Modal>
      )}
      <Section>
        <Content>
          <TextDiv>
            <h3>
              {returnTypeIs(type)} 정상적으로
              <br />
              변경되었습니다.
            </h3>
          </TextDiv>
          <ImgWrap margintop="11.3" imgwidth="20">
            <img src={returnTypeImg(type)} alt="" />
          </ImgWrap>
        </Content>
        <Btns>
          <ButtonL
            onClick={
              type == "password"
                ? () => {
                    setOpenModal(true);
                  }
                : () => {
                    // navigate("/mypage/edit");
                    navigate("/mypage/edit", {
                      state: { result: true, params: true },
                    });
                  }
            }
          >
            확인
          </ButtonL>
        </Btns>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default EditInfoResult;
